module.exports = __webpack_public_path__ + "static/media/groupes.c29e7f32.svg";